import { Tag } from 'foundations-components/transitional/components/Tag';
import { getSLATagColorFromStatus, getSLAIconColorTokenFromStatus } from 'svh-tickets-lib/tickets/public/operators';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import SLADueDate from './SLADueDate';
import { TimeIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ActiveSLAAlert = ({
  activeSLA
}) => {
  const tagColor = getSLATagColorFromStatus(activeSLA.status);
  const iconColor = getSLAIconColorTokenFromStatus(activeSLA.status);
  return /*#__PURE__*/_jsxs(Tag, {
    use: tagColor,
    children: [/*#__PURE__*/_jsx(IconHolder, {
      icon: TimeIcon,
      color: iconColor,
      padding: "0",
      paddingBlock: "100",
      marginInlineEnd: "100"
    }), /*#__PURE__*/_jsx(SLADueDate, {
      slaCategory: activeSLA.category,
      dueDate: activeSLA.dueDate
    })]
  });
};
ActiveSLAAlert.displayName = 'ActiveSLAAlert';
export default ActiveSLAAlert;